import React from 'react';
import { Tooltip, Typography, Link } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

interface InfoTooltipProps {
	text: string;
	linkUrl: string;
	linkLabel: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ text, linkUrl, linkLabel }) => {
	return (
		<Tooltip
			title={
				<Typography variant="body2">
					{text}{' '}
					<Link
						href={linkUrl}
						target="_blank"
						rel="noopener"
						underline="always"
						sx={{
							color: 'inherit',
							fontWeight: 'inherit',
							fontSize: 'inherit',
							textDecorationColor: 'currentColor'
						}}
					>
						{linkLabel}
					</Link>
				</Typography>
			}
			placement="right"
			arrow
		>
			<InfoIcon color="warning" />
		</Tooltip>
	);
};

export { InfoTooltip };
